import { ArrowTurnUpLeftIcon, DocumentTextIcon } from "@heroicons/react/24/outline";
import { unwrapConnection } from "@utils/utils";

import {
  DropdownMenuItem,
  DropdownMenuPortal,
  DropdownMenuSub,
  DropdownMenuSubContent,
  DropdownMenuSubTrigger,
} from "@fronterahealth/frontera-ui-components/ui/dropdown-menu";

import { ReportSectionFieldsType, ReportSectionsType } from "@api/graphql/types-and-hooks";
import { useMoveFieldToSection } from "@components/ReportField/ReportFieldDropdownMenu/useMoveFieldToSection";
import { APPENDIX_PAGE_LOCATION } from "@components/ReportField/consts";
import { useReport } from "@providers/ReportProvider";

interface Props {
  section: ReportSectionsType;
  field: ReportSectionFieldsType;
}

export const ReportFieldDropdownMenuReturnFromAppendix: React.FC<Props> = ({ section, field }) => {
  const { report } = useReport();
  const moveToSectionMutate = useMoveFieldToSection();

  const reportSections = unwrapConnection(report.reportSections) ?? [];
  const nonAppendixSections = reportSections
    .filter((target) => target.pageLocation !== APPENDIX_PAGE_LOCATION && target.id !== section.id)
    .sort((a, b) => a.rankOrder - b.rankOrder);

  return (
    <DropdownMenuSub>
      <DropdownMenuSubTrigger>
        <ArrowTurnUpLeftIcon />
        Move to Section
      </DropdownMenuSubTrigger>
      <DropdownMenuPortal>
        <DropdownMenuSubContent>
          {nonAppendixSections.length ? (
            nonAppendixSections.map((target) => (
              <DropdownMenuItem
                key={target.id}
                onClick={() => moveToSectionMutate({ fieldId: field.id, targetSectionId: target.id })}
              >
                <DocumentTextIcon />
                {target.title}
              </DropdownMenuItem>
            ))
          ) : (
            <DropdownMenuItem disabled>No Section Found</DropdownMenuItem>
          )}
        </DropdownMenuSubContent>
      </DropdownMenuPortal>
    </DropdownMenuSub>
  );
};
